<template>
	<div>
		<!-- Amount -->
		<label class="block fs3 fw7 mb1" for="amount">Amount</label>
		<j-base-input-number v-model="form.amount" id="amount" @input="onInput" />

		<!-- Currency -->
		<label class="block fs3 fw7 mb1 mt4" for="currency">Currency</label>
		<j-base-select
			v-model="form.currency"
			:options="options.currencies"
			id="currency"
			@input="onInput"
		/>
	</div>
</template>

<script>
import JBaseInputNumber from "@/components/JBaseInputNumber"
import JBaseSelect from "@/components/JBaseSelect"

export default {
	components: { JBaseInputNumber, JBaseSelect },

	data() {
		return {
			form: {
				amount: 0,
				currency: ""
			},

			options: {
				currencies: [
					{
						name: "AED",
						value: "AED"
					},
					{
						name: "AUD",
						value: "AUD"
					},
					{
						name: "BND",
						value: "BND"
					},
					{
						name: "EUR",
						value: "EUR"
					},
					{
						name: "IDR",
						value: "IDR"
					},
					{
						name: "INR",
						value: "INR"
					},
					{
						name: "KRW",
						value: "KRW"
					},
					{
						name: "LKR",
						value: "LKR"
					},
					{
						name: "MUR",
						value: "MUR"
					},
					{
						name: "MYR",
						value: "MYR"
					},
					{
						name: "PHP",
						value: "PHP"
					},
					{
						name: "PKR",
						value: "PKR"
					},
					{
						name: "QAR",
						value: "QAR"
					},
					{
						name: "SAR",
						value: "SAR"
					},
					{
						name: "SGD",
						value: "SGD"
					},
					{
						name: "THB",
						value: "THB"
					},
					{
						name: "USD",
						value: "USD"
					},
					{
						name: "TWD",
						value: "TWD"
					},
					{
						name: "CNY",
						value: "CNY"
					},
					{
						name: "JPY",
						value: "JPY"
					},
					{
						name: "OMR",
						value: "OMR"
					},
					{
						name: "HKD",
						value: "HKD"
					},
					{
						name: "GBP",
						value: "GBP"
					}
				]
			}
		}
	},

	methods: {
		onInput() {
			this.$emit(
				"input",
				JSON.stringify([
					{ key: "amount", value: { numberValue: this.form.amount } },
					{ key: "currency", value: { stringValue: this.form.currency } }
				])
			)
		}
	}
}
</script>
